import { PermissionTypes } from 'features/permissions/types';

export const PRESENT_CONTENT_DYNAMIC_PERMISSIONS = [
  PermissionTypes.presentContentLibrary,
  PermissionTypes.pushContent,
];

export const removeDynamicPresentContentPermissions = (dynamicPermissions: PermissionTypes[]) => {
  const permissionsToRemove = new Set(PRESENT_CONTENT_DYNAMIC_PERMISSIONS);

  return dynamicPermissions.filter((permission) => !permissionsToRemove.has(permission));
};
